import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card} from 'antd';
import {getTax, getTaxRates} from './actions';
import {bindActionCreators} from "redux";
import DateTimeDisplay from "../common/DateTimeDisplay";
import ResponsiveTable from "../common/ResponsiveTable";
import {decodeParams} from "../utils/params";

const taxesRatesColumns = [
  {
    title: 'Effective Date',
    dataIndex: 'effectiveDate',
    key: 'effectiveDate',
    render: value => <DateTimeDisplay dateTime={value}/>
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: 'rate'
  },
];

class TaxesRatesPage extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.taxId !== prevProps.match.params.taxId) this._load();
  }

  _load = (newPagination) => {
    const {taxId} = decodeParams(this.props.match.params);
    const {pagination} = this.props;
    this.props.getTax({taxId});
    this.props.getTaxRates({taxId, pagination: newPagination || pagination});
  };

  handleUpdate = e => {
    const {taxId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.history.push('/tax/update-rate/' + taxId);
  };

  render() {
    const {loading, tax, taxRates, pagination, history} = this.props;
    return (
      <Card
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          ` ${tax.name} Rates`
        ]}
        extra={<Button type="primary" icon="edit" onClick={this.handleUpdate}>Update</Button>}
      >
        <ResponsiveTable
          loading={loading}
          columns={taxesRatesColumns}
          dataSource={taxRates}
          rowKey={row => (`${row.taxId}-${row.rateId}`)}
          pagination={pagination}
          onChange={this._load}
        />
      </Card>
    );
  }
}

TaxesRatesPage.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  getTaxRates: PropTypes.func.isRequired,
  taxRates: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  getTax: PropTypes.func.isRequired,
  tax: PropTypes.object.isRequired,
  pagination: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  taxRates: state.tax.taxRates,
  loading: state.tax.taxLoading || state.tax.taxRatesLoading,
  tax: state.tax.tax || {},
  pagination: state.tax.taxRatesPagination,
});

const mapDispatchToProps = dispatch => ({
  getTax: payload => (dispatch(getTax(payload))),
  getTaxRates: bindActionCreators(getTaxRates, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxesRatesPage);



// WEBPACK FOOTER //
// ./src/Tax/TaxesRatesPage.js